export default "assets/fr-3cdaee08.svg";